import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * The shared "guardar / seguir" star toggle used across the app (contracting
 * rows, the detail header, and price-item rows). Always rendered as a circle so
 * every star looks and animates the same. Pass `badge` to show a `+N` overlay
 * (e.g. profile items pending to be merged).
 */
export function StarButton({
  saved,
  onClick,
  title,
  disabled,
  badge,
  className,
}: {
  saved: boolean;
  onClick: (e: React.MouseEvent) => void;
  title?: string;
  disabled?: boolean;
  badge?: number;
  className?: string;
}) {
  const hasBadge = badge != null && badge > 0;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={cn(
        "relative flex size-8 cursor-pointer items-center justify-center rounded-full border bg-card transition-colors hover:bg-accent/30 active:scale-90 disabled:opacity-50",
        className,
      )}
    >
      <Star
        className={cn(
          "size-4 transition-all duration-200",
          // Saved with pending items: amber outline (not filled) to invite the
          // merge. Saved & complete: solid amber. Not saved: muted.
          saved && hasBadge && "scale-110 text-amber-500",
          saved && !hasBadge && "scale-110 fill-amber-500 text-amber-500",
          !saved && "text-slate-400 dark:text-slate-500",
        )}
      />
      {hasBadge && (
        <span className="absolute -right-1 -top-1 flex size-4 items-center justify-center rounded-full bg-blue-500 text-[9px] font-bold leading-none text-white">
          +{badge}
        </span>
      )}
    </button>
  );
}
